import * as React from 'react';
import { usePreparedMembershipLogs } from '../../utils/usePreparedMembershipLogs';
import { usePreparedDeviceStatusLogs } from '../../utils/usePreparedDeviceStatusLogs';
import { EnterpriseEnrollmentExtended } from '../../api/useGetEnterpriseMemberDetails';
import Section from '@hero/ui-kit/layout/Section';
import Container from '@hero/ui-kit/layout/Container';
import DeviceLogLineItem from '../DeviceLogLineItem';
import * as Style from './style.module.css';
import P from '@hero/ui-kit/typography/P';
import H from '@hero/ui-kit/typography/H';

interface MemberLogsProps {
    enrollment: EnterpriseEnrollmentExtended;
}

const MemberLogs: React.FC<MemberLogsProps> = ({ enrollment }) => {
    const preparedMembershipLogs = usePreparedMembershipLogs(enrollment.logs.membership_logs);
    const preparedDeviceStatusLogs = usePreparedDeviceStatusLogs(
        enrollment.logs.device_statuses || []
    );

    return (
        <Section noDefaultPadding>
            <Container gridTemplateColumns={'1fr'} gridColumnGap="small">
                <div>
                    <H role="h6" styles={{ margin: '0 0 1rem 0' }}>
                        Membership logs
                    </H>

                    <Section noDefaultPadding marginVertical="regular">
                        {!preparedMembershipLogs.length ? (
                            <P>No Membership logs available</P>
                        ) : (
                            <ul className={`${Style.table} ${Style.compact} ${Style.zebra}`}>
                                {preparedMembershipLogs.map((item, index) => {
                                    return (
                                        <li key={`${index}-${item.timestamp}-${item.title}`}>
                                            <Container
                                                gridTemplateColumns={'2fr 2fr  1fr'}
                                                gridColumnGap="regular"
                                            >
                                                <P noDefaultMargin strong>
                                                    {item.title}
                                                </P>

                                                <P noDefaultMargin>{item.description}</P>

                                                <div className="align-right ">{item.timestamp}</div>
                                            </Container>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </Section>
                </div>

                <div>
                    <H role="h6" styles={{ margin: '0 0 1rem 0' }}>
                        Device status log
                    </H>

                    {preparedDeviceStatusLogs.length > 0 ? (
                        <Section noDefaultPadding marginVertical="regular">
                            <ul className={`${Style.table} ${Style.compact} ${Style.zebra}`}>
                                {preparedDeviceStatusLogs.map((item, index) => (
                                    <li key={`${index}-${item.timestamp}-${item.title}`}>
                                        <DeviceLogLineItem item={item} />
                                    </li>
                                ))}
                            </ul>
                        </Section>
                    ) : (
                        <P>No device status logs available</P>
                    )}
                </div>
            </Container>
        </Section>
    );
};

export default MemberLogs;
